import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js"
import { Dispatch } from "redux"
import { clearLoggedInUser } from "../redux/reducers/userReducer"
import {resetClientId} from '../authentication/clientIdService'
import { logDiagnosticEvent } from '../services/diagnosticLogger'
import oktaService from '../services/oktaService'

export class LogoutHelper {
    private dispatch: Dispatch
    private oktaAuth: OktaAuth

    // Stable reference so tokenManager.off() can deregister the exact same handler
    // that tokenManager.on() registered.
    private readonly handleTokenExpired = (): void => {
        const userId = this.oktaAuth.tokenManager.getTokensSync?.().idToken?.claims?.preferred_username

        logDiagnosticEvent({ eventType: 'token_expired_detected', userId, outcome: 'expired', level: 'warn' })

        logDiagnosticEvent({ eventType: 'redirect_to_okta', userId, outcome: 'token_expired', level: 'warn' })
        // Route through the centralized guard so the tokenManager "expired"
        // listener cannot race with ProtectedRoute / 401 interceptors and
        // overwrite the PKCE code_verifier in session storage.
        oktaService.triggerOktaRedirect(toRelativeUrl(window.location.href, window.location.origin))
    }

    constructor(oktaAuth: OktaAuth, dispatch: Dispatch) {
        this.oktaAuth = oktaAuth
        this.dispatch = dispatch
    }

    /* eslint-disable class-methods-use-this */
    IfExternalURL() {
        return window.location.href.includes('hillsidenewmedia')
    }
    /* eslint-enable class-methods-use-this */

    async handleLogout() {
        resetClientId()

        if (this.IfExternalURL()) {
            await this.oktaAuth.signOut()
        } else {
            // Reuse the centralized, guarded redirect so the tokenManager "expired"
            // listener cannot race with ProtectedRoute / 401 interceptors and
            // overwrite the PKCE code_verifier in session storage.
            await oktaService.triggerOktaRedirect()
            this.dispatch(clearLoggedInUser())
        }
    }

    getLogoutButtonLabel() {
        if (this.IfExternalURL()) {
            return "Logout"
        }
        return "Resync Okta"

    }

    oktaExpiryListeners() {
        if (this.IfExternalURL()) {
            // Go straight to Okta for re-authentication when a token expires,
            // saving the current Planner URL so the user is returned here after login.
            // This mirrors what ProtectedRoute does and avoids the double-hop through
            // Portal that occurred when using oktaService.redirectToOktaSignIn().
            this.oktaAuth.tokenManager.on('expired', this.handleTokenExpired)

            return () => {
                this.oktaAuth.tokenManager.off('expired', this.handleTokenExpired)
            }
        }
    }
}
